export default __webpack_public_path__ + "static/media/caret-down.107b9ed2.svg";